import { useEffect, type ReactNode } from 'react';
import { useDnd } from './Canvas';
import { IconButton } from '../ui/controls';

/**
 * Shows a Studio panel normally on big windows, and as a slide-in drawer over the canvas on smaller ones.
 * While a widget is being dragged out of the library, the drawer fades so the canvas underneath is visible
 * (it stays mounted, so the drag carries on).
 */
export function Drawer({ side, enabled, open, onClose, label, children }: { side: 'left' | 'right'; enabled: boolean; open: boolean; onClose: () => void; label: string; children: ReactNode }) {
  const dragging = useDnd((s) => !!s.type);
  useEffect(() => {
    if (!enabled || !open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && !document.querySelector('.scrim, .popover')) onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [enabled, open, onClose]);
  if (!enabled) return <>{children}</>;
  return (
    <div className={`drawer ${side}${open ? ' open' : ''}${dragging ? ' passing' : ''}`} role="dialog" aria-label={label} aria-hidden={!open} inert={!open || undefined}>
      <IconButton icon="x" label={`Close ${label.toLowerCase()}`} size="sm" className="drawer-close" onClick={onClose} />
      {children}
    </div>
  );
}
